<template>
  <div>
    <div>
      <transition-group
        tag="div"
        enter-active-class="enter-active"
        enter-class="enter"
        leave-active-class="leave-active"
        leave-to-class="leave-to"
      >
        <!-- @mouseenter="paused = true"
        @mouseleave="paused = false" -->
        <img v-for="(image, index) in images"
             v-show="activeIndex === index"
             :key="index"
             class="image"
             :class="[onlyAutomatic ? 'main-banner' : '']"
             alt=""
             v-bind:style="{backgroundImage: 'url(' + image + ')'}"
             style="background-repeat: no-repeat; background-size: contain; background-position: center; background-color: #fff;"
        />
      </transition-group>
    </div>
    <div v-if="award" class="award"><img src="../assets/images/award.png"></div>
    <div v-if="!onlyAutomatic" class="slider-btn next" @click="nextClick"></div>
    <div v-if="!onlyAutomatic" class="slider-btn prev" @click="prevClick"></div>
  </div>
</template>

<script>
  export default {
    name: 'ImageSlider',
    props: {
      hasMovie: {
        default: false,
        type: Boolean
      },
      images: {
        type: Array
      },
      interval: {
        default: 2500,
        type: Number
      },
      onlyAutomatic: {
        default: false,
        type: Boolean
      },
      award: {
        default: false,
        type: Boolean
      }
    },
    data () {
      return {
        activeIndex: 0,
        time: this.interval,
        clock: null
        // paused: false,
      }
    },
    computed: {},
    created () {
      this.startInterval()
    },
    methods: {
      goToIndex (index) {
        this.activeIndex = index
        this.time = this.interval
      },
      next () {
        let nextIndex = this.activeIndex + 1

        // Go to the first image if the active
        // image ist the last one.
        if (!this.images[nextIndex]) {
          nextIndex = 0
        }

        this.goToIndex(nextIndex)
      },
      prev () {
        let nextIndex = this.activeIndex - 1

        // Go to the last image if the active
        // image is the first one.
        if (!this.images[nextIndex]) {
          nextIndex = this.images.length - 1
        }

        this.goToIndex(nextIndex)
      },
      startInterval () {
        const precision = 100
        this.clock = setInterval(() => {
          this.time -= precision
          // if (!this.paused) this.time -= precision
          if (this.time <= 0) this.next()
        }, precision)
        // Clear the interval if the component
        // is destroyed to prevent memory leaks.
        this.$once('hook:destroyed', () => clearInterval(this.clock))
      },
      nextClick () {
        if (this.clock) {
          clearInterval(this.clock)
          this.clock = null
        }
        this.next()
      },
      prevClick () {
        if (this.clock) {
          clearInterval(this.clock)
          this.clock = null
        }
        this.prev()
      }
    }
  }
</script>

<style lang="scss" scoped>
    .enter-active,
    .leave-active {
        transition: opacity 1s;
    }

    .enter,
    .leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageSlider.vue